import { mapDesigns } from "@mono/mapDesigns"
import { socket } from "@/utils/utils"
import { useAppSelector } from "@/store/hooks"
import { MainButton } from "@/Components/MainButton"
import Color from "color"
import { allColors } from "@/utils/data"
import Money from "@/Components/Money"
import Modal from "@/Components/Modal"

interface JailModalProps {}

const JailModal: React.FC<JailModalProps> = () => {
  const myGame = useAppSelector((state) => state.global.myGame)
  const modalData = useAppSelector((state) => state.global.modalData)
  const jailModalData = modalData.jail
  const pay50 = () => {
    socket.emit("game.jailFreeOptionChoosed", myGame?.id || "", "pay50")
  }
  const rollForDoubles = () => {
    socket.emit(
      "game.jailFreeOptionChoosed",
      myGame?.id || "",
      "roll-for-doubles"
    )
  }
  const useJailFreeCard = () => {
    socket.emit(
      "game.jailFreeOptionChoosed",
      myGame?.id || "",
      "use-jail-free-card"
    )
  }
  return (
    <Modal
      data-testid="game.jail-modal"
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10"
      icon={<i className="fa-solid fa-handcuffs text-white text-2xl"></i>}
      title="You're in Jail"
      subtitle="Choose how to get out"
      contentClassName="flex flex-col gap-4 px-8 pb-8"
    >
      <MainButton
        onClick={pay50}
        baseColor={new Color(allColors.buttonBaseColors.red).hex()}
        data-testid="game.jail-modal.pay-50"
      >
        <div className="flex items-center gap-2">
          <i className="fa-money-bill-wave fa-solid text-white fa-xl"></i>
          <div className="text-white font-medium font-poppins flex text-xl">
            Pay
            <Money money={50} className="gap-2" iconClass="h-1/2"></Money>
          </div>
        </div>
      </MainButton>
      <MainButton
        onClick={rollForDoubles}
        data-testid="game.jail-modal.roll-for-doubles"
        baseColor={new Color(allColors.buttonBaseColors.blue).hex()}
      >
        <div className="flex items-center gap-2">
          <i className="fa-dice fa-solid text-white fa-xl"></i>
          <div className="text-white font-medium font-poppins text-xl">
            Roll for doubles
          </div>
        </div>
      </MainButton>
      {jailModalData.showOptionForUseJailFreeCard && (
        <MainButton
          className="btn"
          onClick={useJailFreeCard}
          data-testid="game.jail-modal.use-jail-free-card"
          baseColor={new Color(allColors.buttonBaseColors.green).hex()}
        >
          <div className="flex items-center gap-2">
            <i className="fa-ticket fa-solid text-white fa-xl"></i>
            <div className="text-white font-medium font-poppins text-xl">
              Use Jail Free card
            </div>
          </div>
        </MainButton>
      )}
    </Modal>
  )
}

export default JailModal
